/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
import 'babel-polyfill';

import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';

import WLP3 from '@/WLP3';
import routes from "@/routes";
import "@/assets/styles/main.scss";
import WLP3Store from '@/store/index';
import VueConfig from '@/classes/config/index';
import 'bootstrap/dist/css/bootstrap.css';
import * as Resize from 'iframe-resizer/js/iframeResizer.contentWindow';
import vueScrollto from 'vue-scrollto';
import device from "vue-device-detector";
import i18n from './i18n'


export function main(el, apiKey, serviceUrl, serviceUrl2, gaId, locationId, locale) {
  Vue.use(VueRouter);
  Vue.use(Vuex);
  Vue.use(BootstrapVue);
  Vue.use(Vuelidate);
  Vue.use(Resize);
  Vue.use(vueScrollto);
  Vue.use(device);

  Vue.use(VueConfig, {
    config: {
      apiKey: apiKey,
      serviceUrl: serviceUrl,
      serviceUrl2: serviceUrl2,
      gaId: gaId,
      locationId: locationId
    }
  });

  const router = new VueRouter({
    routes
  });

  i18n.locale = locale;

  new Vue({
    i18n,
    render: h => h(WLP3),
    router: router,
    store: new WLP3Store()
  }).$mount(el);
}
